import {batch, computed, signal} from "@preact/signals-react";
import {isEmpty} from "@ui-seeker/utils";

export const isLoadingUserSettingSitesGroupData = signal(true)
export const userSettingSitesGroupData = signal([])
export const userSettingsSitesGroupFormData = signal({})

export const isOpenUserSettingsSitesGroupDrawer = computed(() => !isEmpty(userSettingsSitesGroupFormData.value))
export const isEditUserSettingsSitesGroupDrawer = computed(() => userSettingsSitesGroupFormData.value?.id !== null)

export const clearUserSettingSitesGroupSignals = () => batch(() => {
    isLoadingUserSettingSitesGroupData.value = true
    userSettingSitesGroupData.value = []
    userSettingsSitesGroupFormData.value = {}
})